import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MultiDropdown from '@/components/MultiDropdown';
import CategoriesLinkIcon from '@/components/CategoriesLinkIcon';
import DropdownItem from '@/util/DropdownItem';
import DropdownButton from '@/components/DropdownButton';
import { SavedQueryCategory } from '@/views/SavedQueries/types';
import styles from './FilterItem.module.scss';

export type FilterItemProps = {
  category: SavedQueryCategory;
  path: string;
  active: boolean;
  onApplyFilter: F0<void>;
  onEdit: F0<void>;
  onDelete: F0<void>;
};

export const FilterItem: React.FC<FilterItemProps> = ({
  category,
  active,
  path,
  onApplyFilter,
  onEdit,
  onDelete,
}) => {
  // TODO: get rid of refs.
  const containerRef = React.useRef<HTMLDivElement>(null);
  const countRef = React.useRef<HTMLSpanElement>(null);

  const handleApplyFilter = (e: React.MouseEvent) => {
    if (e.target === containerRef.current || e.target === countRef.current) {
      onApplyFilter();
    }
  };

  return (
    <div
      id={category.id()}
      ref={containerRef}
      onClick={handleApplyFilter}
      className={`${styles.container} ${active ? styles.activeFilter : ''}`}
    >
      {category.name()}
      <div className={styles.controlsContainer}>
        <div className={styles.copyButtonContainer}>
          <CategoriesLinkIcon index={category.id()} path={path} />
        </div>
        <div className={styles.controlsButtonContainer}>
          <DropdownButton
            contentBuilder={() => (
              <MultiDropdown
                items={[
                  // @ts-expect-error: get rid of MultiDropdown and DropdownItem
                  DropdownItem.action(<span>Rename</span>, onEdit),
                  // @ts-expect-error: get rid of MultiDropdown and DropdownItem
                  DropdownItem.dropdownWithConfirmation(
                    <span>Delete</span>,
                    onDelete,
                  ),
                ]}
              />
            )}
          >
            <div className={styles.icon}>
              <FontAwesomeIcon icon="ellipsis-v" />
            </div>
          </DropdownButton>
        </div>
        <span ref={countRef} className="faint margin-right-5">
          ({category.count()})
        </span>
      </div>
    </div>
  );
};
